<header id="headerRef" [class.is-scrolled]="isScrolled" [class.menu-open]="menuOpen">

  <span id="anch"></span>

  <button type="button" class="burger" [class.open]="menuOpen" (click)="toggleMenu()"
    [attr.aria-expanded]="menuOpen" aria-label="Menu">
    <span></span>
  </button>

  <nav class="nav-1">
    <ul>
      <li class="social-menu">
        <a href="https://vk.com/ira.shilova.pisatel" target="_blank" rel="noreferrer"
          [gaTrack]="{ event: 'outbound_click', params: { link_type: 'social', network: 'vk', placement: 'header' } }"><img
            src="assets/footer-icons/VK.webp" alt="vk" class="social-icon" width="15" title="vk" height="15" /></a>
        <a href="https://www.instagram.com/ira_shilova_pisatel/" target="_blank" rel="noreferrer"
          [gaTrack]="{ event: 'outbound_click', params: { link_type: 'social', network: 'instagram', placement: 'header' } }"><img
            src="assets/footer-icons/instagram.webp" alt="instagram" title="instagram" class="social-icon" width="15"
            height="15" /></a>
        <a href="https://www.facebook.com/irin.untitled/" target="_blank" rel="noreferrer"
          [gaTrack]="{ event: 'outbound_click', params: { link_type: 'social', network: 'facebook', placement: 'header' } }"><img
            src="assets/footer-icons/facebook.webp" alt="facebook" title="facebook" class="social-icon" width="15"
            height="15" /></a>
        <a href="https://t.me/ira_pro_istorii" target="_blank" rel="noreferrer"
          [gaTrack]="{ event: 'outbound_click', params: { link_type: 'social', network: 'telegram', placement: 'header' } }"><img
            src="assets/footer-icons/telegram.png" title="telegram" alt="telegram" class="social-icon" width="15"
            height="15" /></a>
      </li>
      <li> <a routerLink="/about" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">{{_translationsService.getTranslations().menu.about}}</a></li>
      <li><a routerLink="/blog" routerLinkActive="active">{{_translationsService.getTranslations().menu.blog}}</a></li>
    </ul>
  </nav>
  <h1 class="logo"><a routerLink="/about" class="logo-home-link"><img src="assets/pencil-min.webp" alt="header" width="200" height="30" /></a></h1>
  <nav class="nav-2">
    <ul>
      <li> <a routerLink="/book" routerLinkActive="active">{{_translationsService.getTranslations().menu.book}}</a></li>
      <li> <a routerLink="/illustrations" routerLinkActive="active">{{_translationsService.getTranslations().menu.illustrations}}</a>
      </li>
    </ul>
  </nav>
  <nav class="nav-3">
    <span class="menu-lang" *ngIf="_translationsService.getLocal() === 'ru'" (click)="changeLang('en')">
      ENG
    </span>
    <span class="menu-lang" *ngIf="_translationsService.getLocal() === 'en'" (click)="changeLang('ru')">
      РУС
    </span>
  </nav>

  <div class="mobile-nav-backdrop" [class.open]="menuOpen" (click)="closeMenu()"></div>
  <nav class="mobile-nav" [class.open]="menuOpen" [attr.aria-hidden]="!menuOpen">
    <ul>
      <li>
        <a routerLink="/about" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeMenu()">
          {{_translationsService.getTranslations().menu.about}}
        </a>
      </li>
      <li>
        <a routerLink="/blog" routerLinkActive="active" (click)="closeMenu()">
          {{_translationsService.getTranslations().menu.blog}}
        </a>
      </li>
      <li>
        <a routerLink="/book" routerLinkActive="active" (click)="closeMenu()">
          {{_translationsService.getTranslations().menu.book}}
        </a>
      </li>
      <li>
        <a routerLink="/illustrations" routerLinkActive="active" (click)="closeMenu()">
          {{_translationsService.getTranslations().menu.illustrations}}
        </a>
      </li>
      <li class="mobile-nav-lang">
        <button type="button" class="menu-lang-pill" *ngIf="_translationsService.getLocal() === 'ru'" (click)="changeLang('en'); closeMenu()">
          ENG
        </button>
        <button type="button" class="menu-lang-pill" *ngIf="_translationsService.getLocal() === 'en'" (click)="changeLang('ru'); closeMenu()">
          РУС
        </button>
      </li>
    </ul>
  </nav>
  <div class="header-spacer" aria-hidden="true"></div>
</header>


<main>
  <app-cookie-consent></app-cookie-consent>
  <router-outlet (activate)="onRouteActivated()"></router-outlet>
</main>
